import {useCallback, useEffect, useState} from "react";
import _ from "underscore";
import products from "../earth/1.0.0/products";
import µ from "../earth/1.0.0/micro";
import * as d3 from "d3";
import ConfigurationControlMobile from "./ConfigurationControlMobile";
import ConfigurationControlPc from "./ConfigurationControlPc";

const ConfigurationControl = ({ isMobile, earthController, menuDisplayToggle, rightMenuToggle, setRightMenuToggle, mouseMode, setMouseMode, projectionType, setProjectionType, setClimateData, clearMouseModeAction, setClearMouseModeAction, overlayType }) => {
    const [scenarioType, setScenarioType] = useState("ssp585");
    const [isolineValue, setIsolineValue] = useState(50);
    const [isoLineChecked, setIsoLineChecked] = useState(false);
    const [isoLineLabelChecked, setIsoLineLabelChecked] = useState(false);

    const handleClickScenario = (clickedScenario) => (e) => {
        const newAttr = {scenario: clickedScenario};
        setScenarioType(clickedScenario);
        let attr = _.clone(earthController.configuration.attributes);
        let selectedDate = attr.date;
        let scenarioStartDate = products.scenarioPeriod(clickedScenario).startDate;

        if (selectedDate < scenarioStartDate) {
            let currentDate = µ.dateToUTCymd(new Date(Date.now()), "/");
            newAttr.date = currentDate.substring(0, 8) + "01";
        }
        earthController.configuration.save(newAttr);
    }

    const handleClickProjection = (clickedProjection) => (e) => {
        const newAttr = {projection: clickedProjection};
        setProjectionType(clickedProjection);
        earthController.configuration.save(newAttr);
        earthController.clearLocationDetailsCrossSection(true);
        setClearMouseModeAction(true);
    }

    const handleClickMouseMode = (clickedMouseMode) => (e) => {
        µ.clearCanvas(d3.select("#locationpoint").node());
        if (clickedMouseMode === "basic") {
            earthController.configuration.save({ crossSectionMode: false });
            earthController.configuration.save({ areaMeanMode: false });
            earthController.clearAvgAnnualLocationDetails(!(mouseMode === "basic"));
            earthController.clearLocationDetailsCrossSection(true);
            earthController.clearLocationDetailsAreaMean(true);
        } else if (clickedMouseMode === "crossSection") {
            earthController.configuration.save({ crossSectionMode: true });
            earthController.configuration.save({ areaMeanMode: false });
            earthController.clearAvgAnnualLocationDetails(true);
            earthController.clearLocationDetailsCrossSection(!(mouseMode === "crossSection"));
            earthController.clearLocationDetailsAreaMean(true);
        } else if (clickedMouseMode === "areaMean") {
            earthController.configuration.save({ crossSectionMode: false });
            earthController.configuration.save({ areaMeanMode: true });
            earthController.clearAvgAnnualLocationDetails(true);
            earthController.clearLocationDetailsCrossSection(true);
            earthController.clearLocationDetailsAreaMean(!(mouseMode === "areaMean"));
        } else {
            console.log("invalid MouseMode!");
        }
        setMouseMode(clickedMouseMode);
        setClearMouseModeAction(true);
    }

    // contour-isoline
    const handleChangeIsoLine = (targetType) =>  (e) => {
        if (targetType === 'isoLineChecked') {
            setIsoLineChecked(e.target.checked);
            if (!e.target.checked) setIsoLineLabelChecked(false); //IsoLine체크가 해지되면 라벨도 같이 해지되어야 함
            earthController.configuration.save({showContour: e.target.checked, showContourLabel: !e.target.checked ? "" : isoLineLabelChecked});
        } else if (targetType === 'isoLineLabelChecked') {
            setIsoLineLabelChecked(e.target.checked);
            earthController.configuration.save({showContourLabel: e.target.checked});
        } else console.log('Unknown TargetType', targetType);
    }

    const handleChangeIsoLineSlide = (e) => {
        setIsolineValue(e.target.value);
        earthController.configuration.save({step: e.target.value*0.1});
        earthController.isolineThresholdsCallback();
    }

    //최초 렌더링할때 사이드이펙트
    useEffect(() => {
        if (earthController.configuration) {
            //최초 프로젝션 설정
            const configurationProjection = earthController.configuration.get("projection");
            setProjectionType(configurationProjection);
        } // if (earthController.configuration) { end
    }, [earthController])

    //최초 렌더링할때 사이드이펙트
    useEffect(() => {
        if (earthController.configuration) {
            //최초 등치선 설정
            const contour = earthController.configuration.get("showContour");
            const contourLabel = earthController.configuration.get("showContourLabel");
            setIsoLineChecked(contour);
            setIsoLineLabelChecked(contourLabel);
        } // if (earthController.configuration) { end
    }, [earthController])

    //최초 렌더링할때 사이드이펙트
    useEffect(() => {
        if (earthController.configuration) {
            //최초 시나리오 세팅
            const configurationScenario = earthController.configuration.get("scenario");
            setScenarioType(configurationScenario);
        } // if (earthController.configuration) { end
    }, [earthController])

    return isMobile ?
        <ConfigurationControlMobile rightMenuToggle={rightMenuToggle} menuDisplayToggle={menuDisplayToggle} setRightMenuToggle={setRightMenuToggle} scenarioType={scenarioType} handleClickScenario={handleClickScenario} projectionType={projectionType}
                                    handleClickProjection={handleClickProjection} mouseMode={mouseMode} handleClickMouseMode={handleClickMouseMode} isolineValue={isolineValue} isoLineChecked={isoLineChecked}
                                    handleChangeIsoLine={handleChangeIsoLine} isoLineLabelChecked={isoLineLabelChecked} handleChangeIsoLineSlide={handleChangeIsoLineSlide} overlayType={overlayType}></ConfigurationControlMobile> :
        <ConfigurationControlPc rightMenuToggle={rightMenuToggle} menuDisplayToggle={menuDisplayToggle} setRightMenuToggle={setRightMenuToggle} scenarioType={scenarioType} handleClickScenario={handleClickScenario} projectionType={projectionType}
                                handleClickProjection={handleClickProjection} mouseMode={mouseMode} handleClickMouseMode={handleClickMouseMode} isolineValue={isolineValue} isoLineChecked={isoLineChecked}
                                handleChangeIsoLine={handleChangeIsoLine} isoLineLabelChecked={isoLineLabelChecked} handleChangeIsoLineSlide={handleChangeIsoLineSlide} overlayType={overlayType}></ConfigurationControlPc>
}

export default ConfigurationControl;